import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="pt-24 pb-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-700 mb-6">
            At CIVILSCODE, your privacy is paramount. We are committed to
            protecting the personal information of our users, recognizing the
            trust you place in us as you navigate the journey of UPSC
            preparation on our platform. This Privacy Policy outlines how we
            collect, use, disclose, and safeguard your information when you
            visit our website and use our services.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Information We Collect</b>
          </h2>

          <p className="text-gray-700 mb-4">
            We collect information that helps us deliver a personalized and
            efficient learning experience. This includes, but is not limited to:
          </p>

          <ul className="list-disc pl-6 mb-6 text-gray-700">
            <li className="mb-2">
              Personal Identification Information: Name, email, phone number,
              and other details.
            </li>
            <li className="mb-2">
              Educational Data: Study preferences, quiz results, and progress
              tracking.
            </li>
            <li className="mb-2">
              Technical Data: IP addresses, browser types, and other technology
              on the devices you use to access our platform.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>How We Use Your Information:</b>
          </h2>

          <p className="text-gray-700 mb-4">
            The information we collect is used to:
          </p>

          <ul className="list-disc pl-6 mb-6 text-gray-700">
            <li className="mb-2">
              Provide, operate, and maintain our services.
            </li>
            <li className="mb-2">
              Enhance, personalize, and expand our website.
            </li>
            <li className="mb-2">
              Understand and analyze how you use our platform.
            </li>
            <li className="mb-2">
              Develop new products, services, features, and functionality.
            </li>
            <li className="mb-2">
              Communicate with you, either directly or through one of our
              partners, including for customer service, to provide you with
              updates and other information relating to the website, and for
              marketing and promotional purposes.
            </li>
            <li className="mb-2">
              Send you emails and updates about your progress and new offerings.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Sharing Your Information</b>
          </h2>

          <p className="text-gray-700 mb-6">
            We do not sell, trade, or otherwise transfer to outside parties your
            Personally Identifiable Information unless we provide users with
            advance notice. This does not include website hosting partners and
            other parties who assist us in operating our website, conducting our
            business, or serving our users, so long as those parties agree to
            keep this information confidential. We may also release information
            when its release is appropriate to comply with the law, enforce our
            site policies, or protect ours or others' rights, property or
            safety.
          </p>

          <p className="text-gray-700 mb-6">
            In compliance with the Information Technology Act, 2000 (IT Act),
            and the Information Technology (Intermediary Guidelines and Digital
            Media Ethics Code) Rules, 2021, we ensure that our data handling
            practices respect your privacy rights and adhere to the regulatory
            framework.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Data Security</b>
          </h2>

          <p className="text-gray-700 mb-6">
            We implement a variety of security measures to maintain the safety
            of your personal information. Your personal information is contained
            behind secured networks and is only accessible by a limited number
            of persons who have special access rights to such systems, and are
            required to keep the information confidential.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Your Rights</b>
          </h2>

          <p className="text-gray-700 mb-6">
            Under the IT Act and the Information Technology (Intermediary
            Guidelines and Digital Media Ethics Code) Rules, 2021, you have the
            right to access, correct, or delete your personal data. For any
            requests related to your data rights, please contact us at
            +917995467223
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Changes to Our Privacy Policy</b>
          </h2>

          <p className="text-gray-700 mb-6">
            We reserve the right to update this privacy policy at any time. We
            will notify you of any changes by posting the new privacy policy on
            this page. You are advised to review this Privacy Policy
            periodically for any changes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
